import React from "react";
import { styled, alpha } from "@mui/material/styles";

import { Box } from "../../UI/Box";
import { Grid } from "../../UI/Grid";
import { Typography } from "../../UI/Typography";
import { COLOR_DOWNRIVER, COLOR_WHITE } from "../../constants/styles";
import { HelpTooltip } from "../HelpTooltip";

const StyledContainer = styled(Grid)`
  padding-top: ${(props) => props.theme.spacing(2)};
  width: 330px;
  background: ${COLOR_WHITE};
  box-shadow: 0px 15px 50px rgba(160, 163, 189, 0.1);
  border-radius: 10px;
`;

interface IProps {
  color: string;
  title: string;
  helpTooltip?: string;
  customTooltipText?: React.ReactNode;
  count: number;
  percent?: number | string;
  icon: React.ReactNode;
  footer?: React.ReactNode;
}

export const DashboardCard: React.FC<IProps> = (props) => (
  <StyledContainer container>
    <Grid item pl={3}>
      <Box
        height={60}
        width={60}
        borderRadius={60}
        bgcolor={alpha(props.color, 0.1)}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        {props.icon}
      </Box>
    </Grid>
    <Grid item xs ml="20px" pr={3} pb={2}>
      <Grid container direction="column" >
        <Grid item xs>
          <Typography color={props.color} fontWeight={700} fontSize={29}>
            {props.count}
          </Typography>
        </Grid>
        <Grid item xs sx={{ mb: "9px" }}>
          {(!!props.helpTooltip || !!props.customTooltipText)  && (
            <HelpTooltip title={props.title} text={props.helpTooltip} customText={props.customTooltipText}>
              <Typography color={COLOR_DOWNRIVER} fontSize={14}>
                {props.title}
              </Typography>
            </HelpTooltip>
          )}
          {!props.helpTooltip && !props.customTooltipText && (
            <Typography color={COLOR_DOWNRIVER} fontSize={14}>
              {props.title}
            </Typography>
          )}
        </Grid>
      </Grid>
    </Grid>
    {props.footer && (
      <Grid item xs={12} borderTop={(theme) => `1px solid ${theme.palette.divider}`} px={2} py={1}>
        {props.footer}
      </Grid>
    )}
  </StyledContainer>
);
